export const TermsAndConditionsPage: React.FC = () => (
  <embed
    src={
      process.env.PUBLIC_URL +
      'Gentian-Service-Terms-and-Conditions for Platform Launch (V3) 11 March 2026.docx.pdf'
    }
    type="application/pdf"
    width="100%"
    height="100%"
  />
);
